// extracted by mini-css-extract-plugin
export default {"countdown":"I6-z","srOnly":"J6-z"};